import React, { useEffect, useState } from 'react';
import Footer from "../../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useScrollHeader } from '../../../hooks';

export default function IdentifyMyopia({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false)

  const newsData = [
    {
      title: '什么是弱视？',
      desc: '弱视是一种视觉发育相关疾病，其特征为戴镜视力达不到同龄儿童正常视力下线或者两眼视力相差2行以上，且经眼科检查并未发现能够引起视力差的器质性病变。...',
      date: '2024-10-11',
      img: '/images/home/news3.png',
      route: '/fcst/identifyAmblyopia',
      type: '科普专栏',
    },
    {
      title: '理论突破 - 弱视的皮层下受损',
      desc: '弱视患者的一个重要临床表现在于弱视眼对空间细节的敏感度降低，包括视锐度（眼睛辨别最小视角的能力）降低；对比度敏感度，尤其是对高空间频率（细密纹理）的对比度敏感度降低。...',
      date: '2024-10-31',
      img: '/images/home/news2.png',
      route: '/fcst/breakthroughTheory',
      type: '文献速递',
    },
    {
      title: '方法突破 - 结合增强现实的，可以针对弱视眼P通路进行矫正的双眼图像算法',
      desc: 'Xu等人在2010年证明了通过使用推拉（Push-pull）方法来减少眼优势（sensory eye dominance）的可能性。在训练过程中（图 C），受试者的任务是辨别非优势眼看到中的光栅朝向。 刺激首先向受试者的非优势眼呈现一个矩形框（注意提示），然后分别向双眼呈现一对正交光栅。...',
      date: '2024-10-31',
      img: '/images/home/news1.png',
      route: '/fcst/breakthroughMethod',
      type: '文献速递',
    },
  ]

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return <div>
    <div className="nav">
      <div className="AcademicMargin flex_row flex_jc-sb flex_ai-c gap_10" style={{ height: '100%' }}>
        <div className='nav_title c_ff'>FCST研究院 / 科普专栏 / 【科普】近视防控应该怎么做?</div>
        <div
          className='fz_20 fw_500 lh_24 c_ff cur_p flex_row flex_ai-c'
          onClick={(() => navigate('/fcst', { replace: true }))}
        >
          <img
            className='nav_arrow'
            src='/images/news/left.png'
            alt=''
          />
          <div className='nav_back'>返回页面</div>
        </div>
      </div>
    </div>
    <div className="AcademicBlock">
      <div className='PreA_left'>
        <div className='PreA_marginMobile flex_col flex_jc-sb'>
          <div>
            <div className="article_title">
              <div className='article_titleTop c_85899E'>
                FCST研究院 / 科普专栏
                <span className='ml_54'>2024.10.31</span>
              </div>
              <div className="article_titleBottom">【科普】近视防控应该怎么做?</div>
            </div>
            <div className="article_content">
              <div className="article_content-text1">孩子出现这些症状，可能是近视了</div>
              <ol className="article_content-text">
                <li>眯起眼来看东西;</li>
                <li>频繁揉眼睛、眨眼；</li>
                <li>看东西需要凑近才能看清。</li>
              </ol>
              <div className='article_content-text'>若孩子出现上述表现，可能是近视了，建议尽早带孩子去医院检查视力并矫正。</div>
              <div className="article_content-text1">如何保护孩子视力?</div>
              <div className="article_content-text">
                儿童青少年预防近视首先要坚持户外运动坚持每天日间户外活动不少于2小时。<br /><br />
                0-3岁婴幼儿不使用手机、平板、电脑等视屏类电子产品，3-6岁幼儿尽量避免接触和使用视屏类电子产品，中小学生每天累计视屏时长不宜超过1小时。<br /><br />
                要保持与屏幕适宜的观看距离。电子屏幕的大小不同，适合观看的距离就不同。应根据房间大小、观看距离来选择屏幕尺寸。<br /><br />
                缓解眼睛疲劳，可使用“202020法则":近距离用眼20分钟应该远跳20英尺(约6米)，不少于20秒。<br /><br />
                读写的姿势要做到“三个一":手离笔尖一寸，眼离书本一尺，还有前胸离桌缘一拳。
              </div>
              <div className='mt_20'>
                <img
                  style={{ width: '100%' }}
                  src='/images/fcst/identifyMyopia1.png'
                  alt=''
                />
              </div>
              <div className="article_content-text1">孩子已经近视了怎么办？</div>
              <div className='article_content-text'>
                首先判断是真性近视还是假性近视。<br /><br />
                假性近视<br />
                如果孩子出现"假性近视”，可以让孩子眼睛彻底放松，使眼睛慢慢恢复，如减少近距离用眼等。<br /><br />
                真性近视<br />
                一方面要根据医生和验光师的建议，为孩子及时佩戴眼镜矫正近视。同时要注意加强日间户外活动，减少近距离用眼和电子产品使用，以减少近视发展。同时要每3-6个月到医院复查视力。
              </div>
              <div className="article_content-text1">近视防控产品应该怎么选择？</div>
              <div className="article_content-text">
                严格意义上来说，近视防控应该分为两类，一个是“防”——阻止近视发生，另一个是“控”——控制近视程度增长，但是目前市场上主流的方案都是用于近视度数增长的控制。
              </div>
              <div>
                <img
                  style={{ width: '100%' }}
                  src='/images/fcst/identifyMyopia2.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                目前比较常见的OK镜和阿托品都需要在专业的眼科医生的指导下进行使用，均能在一定程度上控制眼轴的症状，延缓近视度数的加深，但是对已经近视的患者并不能起到“摘镜”的作用；<br /><br />
                年龄较小的近视患者切记盲目进行近视手术，因为未成年人眼部发育未完善，眼球仍处于生长发育阶段，且近视度数不稳定，若盲目接受激光近视手术，首先降低了激光近视手术的安全性，其次术后易出现视力回退、反弹等并发症。
              </div>
              <div className='PreA_img2'>
                <img
                  style={{ width: '100%' }}
                  src='/images/fcst/identifyMyopia3.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                爱格视™ 是一款融合三大功能，眼球+脑视觉双通路防控近视，更全面的近视防控产品。<br /><br />
                其功能包括：<br />
                <div className='flex_col gap_10'>
                  <div>光学远像技术，能够实现看近等同于看远，有效放松睫状肌，缓解视疲劳；</div>
                  <div>3D立体视训练，通过游戏化的方式训练，有效提升孩子调节功能；</div>
                  <div>脑视觉锐化训练，是目前唯一一款用于近视患者的脑视觉训练方案，可直接提升裸眼/矫正视力。</div>
                </div>
              </div>
            </div>
          </div>
          <div className='article_content'>
            <div className='article_content-iconBlock'>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Share_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Collection_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/link_icon.png'
                  alt=''
                />
              </div>
            </div>
            <div className='article_content-btnBlock'>
              {/* Pc端 */}
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/fcst/identifyAmblyopia'))}
              >
                <img
                  className='nav_arrow mr_10'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                阅读上一篇文章
              </div>
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/fcst/breakthroughTheory'))}
              >
                阅读下一篇文章
                <img
                  className='nav_arrow ml_10'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
              {/* 移动端 */}
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/fcst/identifyAmblyopia'))}
              >
                <img
                  className='nav_arrow mr_66'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                上一篇
              </div>
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/fcst/breakthroughTheory'))}
              >
                下一篇
                <img
                  className='nav_arrow ml_6'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="PreA_right">
        <div className="PreA_marginMobile">
          <div className='PreA_right-searchBlock flex_row flex_ai-c'>
            <div className='of_hidden' style={{ width: '100%' }}>
              <input
                className="PreA_input flex_full"
                style={{ width: '100%' }}
                type="text"
                // value={demand}
                // onChange={(e) => setDemand(e.target.value)}
                placeholder="搜索文章"
              />
              <div className='PreA_input-line'></div>
            </div>
            <img
              className='PreA_right-icon flex_auto'
              src='/images/news/right.png'
              alt=''
            />
          </div>
          <div className="article_rightType">
            <div className='fz_18 fw_500 lh_21'>文章分类</div>
            <div className='PreA_right-item flex_center'>科普专栏</div>
          </div>
          <div className="article_rightMore">
            <div className='fz_18 fw_500 lh_21'>更多文章</div>
            <div className="mt_16">
              <div className="of_hidden">
                <div className='article_rightMoreBlock flex_col'>
                  {newsData.map((item, index) => <div
                    key={index}
                    className='article_rightItem cur_p'
                    onClick={(() => navigate(item.route))}
                  >
                    <div className="article_rightItemBlock">
                      <div className='PreA_right-itemImg flex_center'>
                        <img
                          style={{ width: '100%' }}
                          src={item.img}
                          alt=''
                        />
                      </div>
                      <div className='article_rightItem-date c_85899E flex_row flex_jc-sb'>
                        <div>{item.date}</div>
                        <div className='article_rightItem-type'>FCST研究院 / {item.type}</div>
                      </div>
                      <div className='article_rightItem-title of_ellipsis'>{item.title}</div>
                      <div className='article_rightItem-desc multiline-ellipsis-2'>{item.desc}</div>
                    </div>
                  </div>)}
                </div>
              </div>
            </div>
            <div className="PreA_right-btnBlock">
              <div
                className='PreA_right-btn flex_row flex_jc-c flex_ai-c'
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onClick={(() => navigate('/fcst'))}
              >
                更多文章
                <img
                  class="PreA_right-arrow"
                  alt=""
                  src={hovered ? '/images/home/arrow-right-whiteLine.png' : '/images/home/arrow-right-blackLine.png'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
}
